import { render, staticRenderFns } from "./NumberOfInjuriesByManning.vue?vue&type=template&id=25c21f02&scoped=true&"
import script from "./NumberOfInjuriesByManning.vue?vue&type=script&lang=js&"
export * from "./NumberOfInjuriesByManning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c21f02",
  null
  
)

export default component.exports